<template>
  <div ref="sideNav" id="side-nav" :class="['sidenav flex flex-col', { drawer: modelValue }]">
    <div class="flex items-center justify-between">
      <div class="flex items-center">
        <img src="@/embr/assets/images/embr32.png" width="40" class="ml-4" />
        <h4 class="text-white">mondrianswap</h4>
      </div>
      <a href="javascript:void(0)" class="closebtn mr-6" @click="closeNav">&times;</a>
    </div>
    <router-link
      :to="{ name: 'trade' }"
      :class="['item px-6', { [activeClasses]: isTradePage }]"
      @click="trackGoal(Goals.ClickNavTrade)"
    >
      Swap
    </router-link>
    <router-link
      :to="{ name: 'pools' }"
      :class="['item px-6', { [activeClasses]: isInvestPage }]"
      @click="trackGoal(Goals.ClickNavInvest)"
    >
      Pools
    </router-link>
    <router-link
      :to="{ name: 'my-portfolio' }"
      :class="['item px-6', { [activeClasses]: isPortfolioPage }]"
      v-if="isLoggedIn"
    >
      Portfolio
    </router-link>
    <a
      class="item px-4"
      href="https://modrianswap.gitbook.io/modrianswap"
      target="_blank"
      title="This link will open a new window"
      >Docs
    </a>

    <a
      href="https://pdfhost.io/v/3adZ06Tni_Terms_of_Use"
      target="_blank"
      class="item mt-5"
      style="color: #ccc; font-size: 1rem; font-weight: 300;"
      >Terms of Use</a
    >
    <a
      href="https://pdfhost.io/v/UszMXyFl9_Risk_Disclosure"
      target="_blank"
      class="item"
      style="color: #ccc; font-size: 1rem; font-weight: 300;"
      >Risk Disclosure</a
    >
    <a
      href="https://pdfhost.io/v/W4bxayu9w_Cookie_Policy"
      target="_blank"
      class="item"
      style="color: #ccc; font-size: 1rem; font-weight: 300;"
      >Cookie Policy</a
    >
    <a
      href="https://pdfhost.io/v/2Yb79lYoz_Privacy_Policy"

      target="_blank"
      class="item"
      style="color: #ccc; font-size: 1rem; font-weight: 300;"
      >Privacy Policy</a
    >
  </div>
</template>


<script>
import { computed, defineComponent, ref } from 'vue';
import useFathom from '@/composables/useFathom';
import { useRoute } from 'vue-router';
import useApp from '@/composables/useApp';
import useWeb3 from '@/services/web3/useWeb3';

export default defineComponent({
  name: 'SideNav',
  emits: ['selected', 'update:modelValue'],
  props: {
    modelValue: {
      type: Boolean
    }
  },
  setup(props, { emit }) {
    const drawer = ref(props.modelValue);
    const sideNav = ref(null);
    const route = useRoute();
    const { appLoading } = useApp();
    const { account } = useWeb3();

    const activeClasses = 'bg-black text-white dark:bg-gray-800';
    const { trackGoal, Goals } = useFathom();

    const isTradePage = computed(() => route.name === 'trade');
    const isPortfolioPage = computed(() => route.name === 'my-portfolio');
    const isInvestPage = computed(() => route.name === 'invest' || String(route.name).startsWith('pool'));
    const isLoggedIn = computed(() => !appLoading.value && !!account.value);

    function closeNav() {
      sideNav.value?.classList.remove('drawer');
      drawer.value = false;
      emit('selected', drawer.value);
      emit('update:modelValue', drawer.value);
    }

    return {
      trackGoal,
      Goals,
      closeNav,
      activeClasses,
      isTradePage,
      isPortfolioPage,
      isInvestPage,
      isLoggedIn,
      drawer,
      sideNav
    };
  }
});
</script>

<style scoped>
.sidenav {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;

  background: linear-gradient(132deg, rgb(21 14 32), rgb(38 15 69 / 95%));
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 4px 4px 0px rgba(0, 0, 0, 0.25);

  overflow-x: hidden;
  transition: 0.5s;
  transition: all 0.2s ease-in-out;
  padding-top: 30px;
}

.sidenav .item {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 22px;
  color: white;
  display: block;
  transition: 0.3s;
}
.sidenav a:hover {
  color: #f1f1f1;
}
.sidenav .closebtn {
  font-size: 36px;
}
.drawer {
  width: 250px !important;
}

@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }
  .sidenav a {
    font-size: 18px;
  }
}

@media screen and (min-width: 1024px) {
  .sidenav {
    display: none;
  }
}
</style>
